import React from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, DrawerContent, DrawerHeader, DrawerBody } from '@heroui/react';
import {
  useGetOrdersByIdQuery,
  useGetPresetsQuery,
} from 'src/services/orders/orders';
import { JobDetails } from 'src/components/Orders/JobDetails/jobDetails';

interface OrderDetailsSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  orderId: string | null;
}

export function ShipperOrderDetailsSidebar({
  isOpen,
  onClose,
  orderId,
}: OrderDetailsSidebarProps) {
  const { t } = useTranslation();
  const { data: presetData } = useGetPresetsQuery();

  const {
    data: Order,
    isLoading,
    refetch,
  } = useGetOrdersByIdQuery(orderId || '', {
    skip: !orderId || !isOpen,
  });

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      size="md"
      radius="none"
      className="border-l shadow-card z-50 h-full" style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-main)", borderColor: "var(--border-light)" }}
      classNames={{
        wrapper: 'z-[100]',
        base: 'rounded-none',
        closeButton:
          'bg-white/[0.06] m-1 hover:bg-white/[0.09] active:bg-white/[0.06] text-white p-2 z-[200]',
      }}
    >
      <DrawerContent>
        {() => (
          <>
            <DrawerHeader className="border-b border-white/[0.05]">
              <h3 className="font-bold text-md cursor-pointer hover:opacity-80">
                {Order?.orderNumber ? Order.orderNumber : t('order_details.job_details')}
              </h3>
            </DrawerHeader>
            <DrawerBody className="p-0 overflow-y-auto">
              {isLoading ? (
                <div className="flex h-full items-center justify-center p-4">
                  Loading...
                </div>
              ) : Order ? (
                <div className="py-6">
                  <JobDetails
                    Order={Order}
                    presetData={presetData}
                    refetchOrder={refetch}
                  />
                </div>
              ) : (
                <div className="flex h-full items-center justify-center p-4 text-white/50">
                  {t('errors.order_not_found', 'Order details not available')}
                </div>
              )}
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
